import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FiSave } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import * as general from "../../libs/general";

const emptyModel = { id: null, name: "" };

const DivisionEditor = ({
  show,
  model,
  departmentId,
  /** Tên phòng ban — hiển thị khi thêm / cập nhật bộ phận */
  departmentLabel = "",
  onClose,
  onSave,
  onDeleted,
  canDelete = false,
}) => {
  const [form, setForm] = useState(emptyModel);
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (!show) return;
    setForm(model || emptyModel);
    setNameError("");
  }, [show, model]);

  const submit = () => {
    if (!form.name?.trim()) {
      setNameError("Vui lòng nhập tên bộ phận.");
      return;
    }
    setNameError("");
    onSave({ ...form, name: form.name.trim() });
  };

  const handleDelete = () => {
    if (!canDelete || !form?.id || departmentId == null) return;
    general.openConfirm(
      async () => {
        try {
          const requestApi = `/api/departments/deleteDivision?departmentId=${departmentId}&divisionId=${form.id}`;
          const response = await axiosInstance.get(requestApi);
          if (!response.data.success) {
            toast.error(response.data.message);
            return;
          }
          toast.success(response.data.message);
          await onDeleted?.();
          onClose();
        } catch (error) {
          console.error(error);
          toast.error(error.message || "Không xóa được bộ phận.");
        }
      },
      `Bạn có chắc chắn muốn xóa bộ phận "${(form.name || "").trim()}" không?`,
      "Xác nhận xóa"
    );
  };

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="department-modal">
      <Modal.Header closeButton>
        <Modal.Title>{form.id ? "Cập nhật bộ phận" : "Thêm bộ phận"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {departmentLabel ? (
          <Form.Group className="mb-3">
            <Form.Label className="text-muted small mb-1">Phòng ban</Form.Label>
            <div className="rounded border bg-light px-2 py-2 small">{departmentLabel}</div>
          </Form.Group>
        ) : null}
        <Form.Group>
          <Form.Label>Tên bộ phận</Form.Label>
          <Form.Control
            value={form.name}
            isInvalid={!!nameError}
            onChange={(e) => {
              const value = e.target.value;
              setForm((prev) => ({ ...prev, name: value }));
              if (value.trim()) setNameError("");
            }}
            autoFocus
          />
          <Form.Control.Feedback type="invalid">{nameError}</Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer
        className={`d-flex align-items-center gap-2 ${
          form?.id && canDelete ? "justify-content-between" : "justify-content-end"
        }`}
      >
        {form?.id && canDelete && (
          <Button
            size="sm"
            variant="outline-danger"
            className="d-inline-flex align-items-center justify-content-center p-1"
            onClick={handleDelete}
            title="Xóa bộ phận"
            aria-label="Xóa bộ phận"
          >
            <RiDeleteBin6Line size={16} />
          </Button>
        )}
        <Button size="sm" className="d-inline-flex align-items-center gap-1" onClick={submit}>
          <FiSave size={14} />
          Lưu
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DivisionEditor;
